/*------------------------------------------
 * BLOCKS: Export Blocks JS
 *------------------------------------------*/

// Import Blocks JS Files
import { ServicesGridReverse } from "./block-services-grid-reverse/_block-services-grid-reverse.js";
import { ServicesGrid } from "./block-services-grid/_block-services-grid.js";
import { Counter } from "./block-counter/_block-counter.js";

//-------------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
  /*--- Initialise imported blocks --- */


    // Initialise all ServicesGridReverse blocks
    document.querySelectorAll(".block-services-grid-reverse").forEach(block => {
    new ServicesGridReverse(block);
});



    // Initialise all ServicesGrid blocks
    document.querySelectorAll(".block-services-grid").forEach(block => {
    new ServicesGrid(block);
});


  // Initialise all Counter blocks
  document.querySelectorAll(".block-counter").forEach((block) => {
    new Counter(block);
  });

});
